import React from 'react';
import { Box, Typography } from '@mui/material';

function Logo({ sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          letterSpacing: '0.3px',
          fontSize: '1.5rem',
        }}
      >
        CareGuide
      </Typography>
    </Box>
  );
}

export default Logo;
